import { Link } from 'react-router-dom';
import { cambiarTutorials } from '@/mocks/quiero-cambiar';

export default function TutorialList() {
  return (
    <div className="flex flex-col gap-4 md:gap-5">
      {cambiarTutorials.map((tutorial) => (
        <article
          key={tutorial.id}
          className="flex flex-col sm:flex-row items-stretch bg-white rounded-2xl border border-sand/40 hover:border-terracotta/40 transition-colors duration-300 overflow-hidden"
        >
          <Link
            to={tutorial.route}
            className="group flex-shrink-0 w-full sm:w-24 md:w-28 lg:w-32 flex items-stretch"
            aria-label={`Ver gratis: ${tutorial.title}`}
          >
            <div className="relative w-full aspect-[4/5] overflow-hidden">
              <img
                src={tutorial.image}
                alt={tutorial.title}
                title={tutorial.title}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-black/0 to-black/0 group-hover:from-black/40 transition-colors duration-300" />
            </div>
          </Link>

          <div className="flex-1 flex flex-col justify-center p-3 md:p-4">
            <div className="flex items-start gap-2.5 mb-2">
              <span className="font-serif text-xl md:text-2xl font-bold text-terracotta leading-none mt-0.5">
                {tutorial.number}
              </span>
              <h3 className="font-serif text-base md:text-lg font-bold text-[#8B6F5C] leading-snug">
                {tutorial.title}
              </h3>
            </div>
            <p className="font-sans text-sm text-[#3D2B1F] leading-relaxed mb-3">
              {tutorial.description}
            </p>
            <div className="flex items-center justify-between flex-wrap gap-2 mt-auto">
              {tutorial.duration ? (
                <span className="inline-flex items-center gap-1.5 font-sans text-xs font-medium text-[#5C4A3A]">
                  <i className="ri-time-line" />
                  Duración: {tutorial.duration}
                </span>
              ) : (
                <span className="inline-flex items-center gap-1.5 font-sans text-xs font-medium text-[#5C4A3A]">
                  <i className="ri-heart-line" />
                  Un momento para vos
                </span>
              )}
              <Link
                to={tutorial.route}
                className="inline-flex items-center gap-1.5 font-sans text-sm font-semibold text-terracotta hover:text-brown transition-colors duration-300 group/btn whitespace-nowrap"
              >
                VER GRATIS
                <i className="ri-arrow-right-line transition-transform duration-300 group-hover/btn:translate-x-1" />
              </Link>
            </div>
          </div>
        </article>
      ))}
    </div>
  );
}